/* StoreFix: BTA (BookThatApp) datepicker + form fallback
   Goal: If BTA hasn't enabled the date inputs (they remain disabled),
   unlock them so customers can still enter dates.

   This does NOT replace BTA availability logic; it only unblocks UX when
   the app script is slow/blocked/cached.
*/
(function () {
  'use strict';

  var SELECTORS = [
    'input.bta-dp-start',
    'input.bta-dp-finish',
    'input[name="properties[From]"]',
    'input[name="properties[To]"]',
    'input[name="properties[Start Date]"]',
    'input[name="properties[Return Date]"]'
  ].join(',');

  function getInputs(root) {
    try {
      return Array.prototype.slice.call((root || document).querySelectorAll(SELECTORS));
    } catch (e) {
      return [];
    }
  }

  function looksInitialized(input) {
    // If a 3rd party datepicker has bound something, it often adds data attributes or classes.
    var cls = (input.className || '').toLowerCase();
    if (cls.indexOf('hasdatepicker') !== -1) return true;
    if (input.dataset && (input.dataset.fp || input.dataset.flatpickr)) return true;
    if (input.getAttribute('aria-haspopup') === 'dialog') return true;
    return false;
  }

  function enableInput(input) {
    if (!input) return;
    if (input.disabled) input.disabled = false;
    // Some themes/apps toggle pointer-events via inline styles
    if (input.style && input.style.pointerEvents === 'none') input.style.pointerEvents = '';
    input.classList.add('storefix-bta-enabled');
  }

  function unlockIfNeeded() {
    var inputs = getInputs();
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      // Only intervene if the field is disabled AND doesn't look initialized.
      if (input.disabled && !looksInitialized(input)) {
        enableInput(input);
      }
    });
  }

  function hookRecheck() {
    // Re-check after common load points
    unlockIfNeeded();
    window.setTimeout(unlockIfNeeded, 1200);
    window.setTimeout(unlockIfNeeded, 3200);
    window.setTimeout(unlockIfNeeded, 6500);

    // If BTA injects/updates the booking form after load, observe and re-unlock.
    try {
      var obs = new MutationObserver(function () {
        unlockIfNeeded();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'style', 'class'] });
      // Stop observing after a while to avoid overhead
      window.setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 15000);
    } catch (e) {}

    // If user clicks a disabled input, unlock immediately
    document.addEventListener('pointerdown', function (e) {
      var t = e && e.target;
      if (!t) return;
      if (t.matches && t.matches(SELECTORS) && t.disabled) {
        enableInput(t);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookRecheck);
  } else {
    hookRecheck();
  }
})();
